import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { FC, useMemo, useState } from "react";

import { Combobox } from "@headlessui/react";
import SearchSelectInput from "./search-select-input";
import _ from "lodash";
import { classNames } from "utils";
import { useEmployees } from "hooks/data/use-employees";

interface EmployeePickerProps {
  id: string;
  label?: string;
  placeholder?: string;
  accessor?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  optionsLoading?: boolean;
  setFieldValue: any;
  setFieldTouched: any;
  setFieldError: any;
  rounded?: boolean;
  rawId?: boolean;
  multiple?: boolean;
}

const EmployeePicker: FC<EmployeePickerProps> = ({
  id,
  label,
  required,
  labelHidden,
  rawId,
  accessor,
  multiple = false,
  ...form
}) => {
  const [query, setQuery] = useState("");
  const { employees, loading } = useEmployees({
    page: 1,
    pageSize: 500,
    offset: 0,
    limit: 500,
    search: "",
    sort: "",
  });

  const options = useMemo(
    () =>
      employees?.map(({ employee_first_name, ...rest }) => ({
        label: `${employee_first_name} ${_.get(
          rest,
          "employee_last_name",
          ""
        )}`,
        value: rawId
          ? _.get(rest, accessor || "employee_id", "")
          : { employee_first_name, ...rest },
      })),
    [accessor, employees, rawId]
  );

  const filteredOptions = useMemo(
    () =>
      query === ""
        ? options
        : options.filter((option) =>
            option.label.toLowerCase().includes(query.toLowerCase())
          ),
    [options, query]
  );

  return (
    <SearchSelectInput
      id={id ?? ""}
      label={label ?? ""}
      labelHidden={labelHidden}
      // description={description}
      required={required}
      placeholder={loading ? "Loading please wait ..." : "Search Employee"}
      optionsLoading={loading}
      rawId={rawId}
      multiple={multiple}
      options={(filteredOptions || [])?.map((item: any) => ({
        label: {
          title: item.label as string,
        },
        value: item?.value?.toString(),
      }))}
      {...form}
    />
  );
};

export default EmployeePicker;
